import { render, staticRenderFns } from "./TileExternal.vue?vue&type=template&id=2dc5b450&scoped=true&"
import script from "./TileExternal.vue?vue&type=script&lang=js&"
export * from "./TileExternal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc5b450",
  null
  
)

export default component.exports